module.exports = __webpack_public_path__ + "static/media/small_tree_row.dd8f107d.png";